<template>
  <section class="bg-skin-primary min-h-template" v-if="GET_PROJECT">
    <NavBar :logo="GET_PROJECT.inform_data.image_url" />
    <MenuMobile v-if="MENUOPEN == true" />
    <MenuModal v-if="OPENMODAL == true" />

    <router-view></router-view>

    <Footer
      :logo="GET_PROJECT.inform_data.image_url"
      :mail="GET_PROJECT.inform_data.contact_email"
      :instagram="GET_PROJECT.inform_data.instagram"
      :facebook="GET_PROJECT.inform_data.facebook"
      :name="GET_PROJECT.name"
      :number="GET_PROJECT.inform_data.contact_number"
      v-if="FOOTER && GET_PROJECT"
    />
    <QualifyModal v-if="OPENQUALIFY == true" />
    <ModalTerms
      iconClose
      v-if="showModal && GET_USER"
      :title="legalCondition.title"
      :content="legalCondition.body"
      @close="showModal = false"
    >
      <button
        @click="acceptTerms"
        class="mx-auto max-w-75 mt-4 flex justify-center text-center w-full item-button col"
        v-text="'Acepto los terminos y condiciones.'"
      />
    </ModalTerms>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "../components/NavBar.vue";
import MenuMobile from "../components/MenuMobile.vue";
import MenuModal from "../components/MenuModal.vue";
import Footer from "../components/Footer.vue";
import QualifyModal from "../components/QualifyModal.vue";
import ModalTerms from "../../../v2/src/components/ModalTerms.vue";
import axios from "axios";

export default {
  components: {
    NavBar,
    MenuMobile,
    MenuModal,
    Footer,
    QualifyModal,
    ModalTerms,
  },
  data() {
    return {
      showModal: false,
      legalCondition: {},
      tagVersion: null,
      legal: null,
    };
  },
  mounted() {
    this.$store.dispatch("project/get_project");
    this.$store.dispatch("getUser/get_user");
    this.$store.dispatch("shopingCart/getCart");

    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches) ||
      localStorage.getItem("theme") == "dark"
    ) {
      localStorage.setItem("theme", "dark");
      document.body.classList.add("theme-dark");
    } else {
      localStorage.setItem("theme", "light");
      document.body.classList.remove("theme-dark");
    }

    if (localStorage.getItem("theme") == "light") {
      document.body.classList.remove("theme-dark");
    }
  },
  methods: {
    async getTerms() {
      let response = await axios.get(
        `/api/v1/legal-document/${
          process.env.VUE_APP_LEGAL_VERSION
        }?proyect_id=${this.GET_PROJECT.id}`
      );

      this.legalCondition = response.data.data;

      this.showModal = !this.GET_USER.acceptLegal;
    },
    acceptTerms() {
      var urlTerms = `/api/v1/legal-conditions/accept?proyect_id=${this.GET_PROJECT.id}`;
      axios.post(urlTerms, {
        accept: true,
        type: 1,
        user_agent: navigator.userAgent,
      });
      this.showModal = false;
    },
  },
  created() {
    this.$store.dispatch("getUser/get_user").then(() => {
      this.getTerms();
    });
  },
  computed: {
    ...mapGetters(["MENUOPEN", "OPENMODAL", "OPENQUALIFY", "FOOTER"]),
    ...mapGetters("project", ["GET_PROJECT"]),
    ...mapGetters("getUser", ["GET_USER"]),
  },
};
</script>

<style scoped>
.min-h-template {
  min-height: 100vh;
}
</style>
